<template lang="pug">
  .list-container
    //- v-sheet
    //-   h3.header-title Gallery
    //-   v-progress-circular(
    //-     v-if="loading"
    //-     indeterminate
    //-     color="primary"
    //-     :size="100"
    //-   )
    //-   v-slide-group(
    //-     v-else
    //-     class="gallery-container"
    //-     v-model="selected"
    //-     center-active
    //-     mobile-breakpoint="1264"
    //-   )
    //-     v-slide-item(
    //-       v-for="(i, index) in banner_list"
    //-       :key="index"
    //-       v-slot="{ active, toggle }"
    //-     )
    //-       v-card(
    //-         :color="active ? 'primary lighten-1' : 'white'"
    //-         class="mt-0 ml-0 ma-4 text-center gallery-item"
    //-         width="144"
    //-         @click="toggle"
    //-       )
    //-         v-img(
    //-           :src="i.banner_url"
    //-           aspect-ratio="1"
    //-           class="grey lighten-2"
    //-         )
    //-           template(v-slot:placeholder)
    //-             v-row(
    //-               class="fill-height ma-0"
    //-               align="center"
    //-               justify="center"
    //-             )
    //-               v-progress-circular(
    //-                 indeterminate
    //-                 color="grey lighten-5"
    //-               )
    //- v-sheet.merchant-gallery
    //-   h3.header-title Gallery
    //-   v-progress-circular(
    //-     v-if="loading"
    //-     indeterminate
    //-     color="primary"
    //-     :size="100"
    //-   )
    //-   v-row(v-else)
    //-     v-col(
    //-       v-for="(i, index) in banner_list"
    //-       :key="index"
    //-       class="d-flex child-flex"
    //-       cols="6"
    //-     )
    //-       v-img(
    //-         :src="i.banner_url"
    //-         aspect-ratio="1"
    //-         class="grey lighten-2"
    //-       )
    //-         template(v-slot:placeholder)
    //-           v-row(
    //-             class="fill-height ma-0"
    //-             align="center"
    //-             justify="center"
    //-           )
    //-             v-progress-circular(
    //-               indeterminate
    //-               color="grey lighten-5"
    //-             )
    v-sheet#merchant
      h3.header-title Stores
        v-btn(class="mx-2" raised small color="primary" @click="toggleDisplay") 
          v-icon mdi-monitor-cellphone
          span.pl-2(v-if="!mobileView") Display: {{ displayType == 0 ? "List" : displayType == 1 ? "Grid" : "" }}
      v-progress-circular(
        v-if="loading"
        indeterminate
        color="primary"
        :size="100"
      )

      //- Display: List for desktop START
      v-card(
        v-else-if="!loading && store_list.length && displayType == 0 && !mobileView"
        v-for="(i, index) in store_list"
        :key="index"
        class="merchant-card mx-auto mt-0 mb-4"
        @click="selectStore(i)"
      )
        template(slot="progress")
          v-progress-linear(
            color="primary"
            height="10"
            indeterminate
          )
        v-img(
          contain
          content-class="merchant-image"
          height="240"
          :src="i.store_imageurl"
        )
          .store-tab(v-if="i.store_vacant") Vacant
          .store-tab-full(v-if="!i.store_vacant") Full
          .business-tab
            .small {{ parseFloat(i.distance ? i.distance : 0).toFixed(2) }} km away
        .merchant-block-25-width.mt-2
          v-card-title.mb-2
            b.merchant-break-word {{ i.store_name }}
          //-v-card-subtitle 
            v-chip(
              v-if="!i.store_vacant"
              small
              outlined
              class="red mt-2"
              label text-color="red darken-4"
            ) Full
            v-chip(
              v-if="i.store_vacant"
              small
              outlined
              class="green mt-2"
              label text-color="green darken-4"
            ) Vacant
          v-card-text
            v-chip(
              class="accent"
              label
            ) 
              v-icon mdi-map-marker
              v-tooltip(bottom)
                template(v-slot:activator="{ on, attrs}")
                  b.ml-2(class="hidden-text-overflow-ellipsis" v-bind="attrs" v-on="on") {{ i.location_name }} 
                span {{ i.location_name }}
            .my-4.subtitle-1 {{ i.store_description }}
        v-divider.mx-4.hide-on-desktop
        .merchant-block.mt-2
          v-card-title.merchant-break-word Today's Business Hours
          v-card-text
            v-chip(
              :class="i.operate_status ? 'green' : 'red'"
              label text-color="white"
            ) {{ i.operate_status ? 'Open' : 'Close' }}
              span(
                v-if="i.operate_status"
                class="ml-2"
              ) {{ i.store_starttime }} to {{ i.store_endtime }}
          v-card-title Customer Review
          v-card-text
            v-row(
              align="center"
              class="mx-0 my-2"
            )
              v-rating(
                :value="parseFloat(i.review_star)"
                color="accent"
                dense
                half-increments
                readonly
                size="14"
              )
              .grey--text.ms-4 {{ parseFloat(i.review_star).toFixed(2) }} ({{ i.review_count }})
        .merchant-block
          v-card-actions
            v-btn(
              class="m-auto"
              color="primary lighten-2"
              text
              @click="selectStore(i)"
            ) View Menu
            //- Display: List for desktop END

      //- Display: List for mobile START
      v-card(
        v-else-if="!loading && store_list.length && displayType == 0 && mobileView"
        v-for="(i, index) in store_list"
        :loading="loading"
        :key="index"
        class="merchant-card mx-auto mt-0 mb-4"
        @click="selectStore(i)"
      )
        template(slot="progress")
          v-progress-linear(
            color="primary"
            height="10"
            indeterminate
          )
        v-img(class="merchant-image" :src="i.store_imageurl" height="240")
          v-layout(align-center justify-center fill-height slot="placeholder")
            v-progress-circular(indeterminate color="primary")
          v-chip(
            class="accent"
            label
          )
            v-icon.mr-2(small) mdi-map-marker
            b.ml-2(class="hidden-text-overflow-ellipsis") {{ i.location_name }} 
          .store-tab(v-if="i.store_vacant") Vacant
          .store-tab-full(v-if="!i.store_vacant") Full
          .business-tab
            .small {{ parseFloat(i.distance ? i.distance : 0).toFixed(2) }} km away
        .merchant-block-25-width.mt-2
          v-card-title
            b.merchant-break-word {{ i.store_name }}
          //-v-card-subtitle.mt-0 
            v-chip(
              v-if="!i.store_vacant"
              small
              outlined
              class="red"
              label text-color="red darken-4"
            ) Full
            v-chip(
              v-if="i.store_vacant"
              small
              outlined
              class="green"
              label text-color="green darken-4"
            ) Vacant
          v-card-subtitle.pb-0.mt-0
            v-chip(
              small
              label
              color="primary"
            ) 
              v-icon.mr-1(left small) mdi-star
              span {{ parseFloat(i.review_star).toFixed(2) }}
              small(
                class="ml-2"
              ) {{ i.review_count }}
          v-card-text.py-0
            .my-4.subtitle-1 {{ i.store_description }}
        v-divider.mx-2.my-1
        .merchant-block.mt-2
          v-card-title.mb-2(class="merchant-break-word") Today's Business Hours
          v-card-text
            v-chip(
              :class="i.operate_status ? 'green' : 'red'"
              label text-color="white"
            ) {{ i.operate_status ? 'Open' : 'Close' }}
              span(
                v-if="i.operate_status"
                class="ml-2"
              ) {{ i.store_starttime }} to {{ i.store_endtime }}
        .merchant-block
          v-card-actions
            v-btn(
              class="m-auto"
              color="primary lighten-2"
              text
              @click="selectStore(i)"
            ) View Menu
            //- Display: List for mobile END

      //- Display: Grid for desktop START
      v-container.p-0(
        v-else-if="!loading && store_list.length && displayType == 1 && !mobileView"
      )
        v-row
          v-col(
            v-for="(i, index) in store_list"
            :loading="loading"
            :key="index"
            sm="6"
            md="6"
            lg="4"
            xl="4"
          )
            v-card(
              height="100%"
              class="mt-1 mb-1"
              @click="selectStore(i)"
              ) 
              v-img(
                height="240"
                class="merchant-image"
                alt="https://kenyaseva.org/static/images/no-image-placeholder-landscape.jpg"
                :src="i.store_imageurl"
              )
                v-layout(align-center justify-center fill-height slot="placeholder")
                  v-progress-circular(indeterminate color="primary")
                v-chip(
                  class="accent"
                  label
                )
                  v-icon.mr-2(small) mdi-map-marker
                  v-tooltip(bottom)
                    template(v-slot:activator="{ on, attrs }")
                      b(v-bind="attrs" v-on="on" class="hidden-text-overflow-ellipsis") {{ i.location_name }} 
                    span {{ i.location_name }}
                .store-tab(v-if="i.store_vacant") Vacant
                .store-tab-full(v-if="!i.store_vacant") Full
                .business-tab
                  .small {{ parseFloat(i.distance ? i.distance : 0).toFixed(2) }} km away
              v-card-title
                v-tooltip(bottom)
                  template(v-slot:activator="{ on, attrs }")
                    b.hidden-text-overflow-ellipsis(v-bind="attrs", v-on="on") {{ i.store_name }}
                  span {{ i.store_name }}
              //-v-card-subtitle.mt-0 
                v-chip(
                  v-if="!i.store_vacant"
                  small
                  outlined
                  class="red"
                  label text-color="red darken-4"
                ) Full
                v-chip(
                  v-if="i.store_vacant"
                  small
                  outlined
                  class="green"
                  label text-color="green darken-4"
                ) Vacant
              v-card-text.py-0
                v-chip(
                  small
                  label
                  color="primary"
                ) 
                  v-icon.mr-1(small) mdi-star
                  span {{ parseFloat(i.review_star).toFixed(2) }}
                  small(
                    class="ml-1"
                  ) {{ i.review_count }}
              v-card-text
                div.subtitle-1(
                  class="merchant-description"
                ) {{ i.store_description }}
              v-divider.mx-2.my-1
              .merchant-block.mt-2
                v-card-title.mb-2(class="merchant-break-word") Today's Business Hours
                v-card-text
                  v-chip(
                    :class="i.operate_status ? 'green' : 'red'"
                    label text-color="white"
                  ) {{ i.operate_status ? 'Open' : 'Close' }}
                    span(
                      v-if="i.operate_status"
                      class="ml-2"
                    ) {{ i.store_starttime }} to {{ i.store_endtime }}
              .merchant-block
                v-card-actions
                  v-btn(
                    class="m-auto"
                    color="primary lighten-2"
                    text
                    @click="selectStore(i)"
                  ) View Menu
                  //- Display: Grid for desktop END
      
      //- Display: Grid for mobile START
      v-container.p-0(
        v-else-if="!loading && store_list.length && displayType == 1 && mobileView"
      )
        v-row(
          dense
        )
          v-col(
            v-for="(i, index) in store_list"
            :loading="loading"
            :key="index"
            cols="6"
          )
            v-card(
              height="100%"
              class="mt-1 mb-1"
              @click="selectStore(i)"
              ) 
              v-img(
                height="120"
                class="merchant-image"
                alt="https://kenyaseva.org/static/images/no-image-placeholder-landscape.jpg"
                :src="i.store_imageurl"
              )
                v-layout(align-center justify-center fill-height slot="placeholder")
                  v-progress-circular(indeterminate color="primary")
                v-chip(
                  small
                  class="accent"
                  label
                )
                  v-icon(x-small) mdi-map-marker
                  v-tooltip(bottom)
                    template(v-slot:activator="{ on, attrs }")
                      b.mobile-font-8px(v-bind="attrs" v-on="on" class="hidden-text-overflow-ellipsis") {{ i.location_name }} 
                    span {{ i.location_name }}
                .store-tab(v-if="i.store_vacant") 
                  span.mobile-font-8px Vacant
                .store-tab-full(v-if="!i.store_vacant") 
                  span.mobile-font-8px Full
                .business-tab
                  .mobile-font-8px(class="pb-0") {{ parseFloat(i.distance ? i.distance : 0).toFixed(2) }} km away
              v-card-title.py-0
                v-tooltip(bottom)
                  template(v-slot:activator="{ on, attrs }")
                    b.mobile-font-8px(v-bind="attrs" v-on="on" class="hidden-text-overflow-ellipsis") {{ i.store_name }}
                  span {{ i.store_name }}
              //-v-card-subtitle.mt-0 
                v-chip.px-1(
                  v-if="!i.store_vacant"
                  x-small
                  outlined
                  class="red"
                  label text-color="red darken-4"
                ) 
                  span.mobile-font-8px Full
                v-chip.px-1(
                  v-if="i.store_vacant"
                  x-small
                  outlined
                  class="green"
                  label text-color="green darken-4"
                ) 
                  span.mobile-font-8px Vacant
              v-card-text.py-0
                v-chip(
                  label
                  x-small
                  color="primary"
                ) 
                  v-icon.mr-1(x-small) mdi-star
                  span.mobile-font-8px {{ parseFloat(i.review_star).toFixed(2) }}
                  small(
                    class="mobile-font-8px ml-1"
                  ) {{ i.review_count }}
              v-card-text.py-0
                div.mobile-font-8px(
                  class="merchant-description"
                ) {{ i.store_description }}
              v-divider.mx-2.my-1
              .merchant-block.mt-2
                v-card-text.mb-0(class="py-0") 
                  b.mobile-font-8px(class="merchant-break-word") Today's Business Hours
                v-card-text.py-0
                  v-chip.px-1(
                    small
                    :class="i.operate_status ? 'green' : 'red'"
                    label text-color="white"
                  ) 
                    span.mobile-font-8px {{ i.operate_status ? 'Open' : 'Close' }}
                    span.mobile-font-8px(
                      v-if="i.operate_status"
                      class="ml-2"
                    ) {{ i.store_starttime }} to {{ i.store_endtime }}
              .merchant-block
                v-card-actions.pt-1
                  v-btn(
                    small
                    class="m-auto"
                    color="primary lighten-2"
                    text
                    @click="selectStore(i)"
                  ) 
                    span.mobile-font-8px View Menu
                  //- Display: Grid for mobile END
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

import StoreList from "@/views/merchant/StoreList";
import StorePage from "@/views/merchant/StorePage";

export default {
  props: {
    store_list: Array
  },
  components: {
    StoreList,
    StorePage
  },
  data() {
    return {
      selected: 0,
      value: 1,
      banner_list: [],
      selectedStore: "",
      selection: 1,
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  computed: {
    mobileView() {
      return this.$vuetify.breakpoint.xs;
    },
    displayType() {
      return this.$store.getters.displayType;
    },
    merchantId() {
      return this.$route.params.merchant;
    }
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    toggleDisplay() {
      this.displayType == 0
        ? this.$store.commit("customer/updateDisplayType", 1)
        : this.displayType == 1
        ? this.$store.commit("customer/updateDisplayType", 0)
        : "";
    },
    selectStore(i) {
      this.$router.push({
        name: "Store",
        params: {
          store: i.store_id
        }
      })
    },
    getBannerList() {
      let url = config.bannerUrl();

      var json = {
        params: {
          merchant_id: this.merchantId,
          store_id: this.merchantId,
          customer_id: this.$store.getters.customerId,
          customer_sessiontoken: this.$store.getters.sessionToken
        }
      };

      this.loading = true;

      this.$http
        .get(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.banner_list = response.body.data;
              } else {
                this.$swal(
                  this.$t("error.get_merchant_banner"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.get_merchant_banner"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.get_merchant_banner"),
            response.body.message,
            "error"
          );
        });
    }
  }
};
</script>
